module.exports = __webpack_public_path__ + "static/img/nine10.d4db1ce7.jpg";